"use client"

import { useEffect } from 'react'

/**
 * ServiceWorkerCleaner
 * Limpia Service Workers y caches del origen cuando
 * NEXT_PUBLIC_SW_CLEANUP === 'true'. Útil como limpieza controlada
 * tras desactivar/ajustar PWA para evitar mezcla de chunks.
 */
export default function ServiceWorkerCleaner() {
  useEffect(() => {
    if (typeof window === 'undefined') return
    const shouldCleanup = process.env.NEXT_PUBLIC_SW_CLEANUP === 'true' || process.env.NODE_ENV !== 'production'
    if (!shouldCleanup) return

    // Evitar doble ejecución en React Strict Mode (dev)
    if ((window as any).__LET_SW_CLEANUP_RUNNING__) return
    ;(window as any).__LET_SW_CLEANUP_RUNNING__ = true

    // Ejecutar solo una vez por sesión
    try {
      if (sessionStorage.getItem('let_sw_cleanup_done') === '1') return
    } catch {}

    ;(async () => {
      let didUnregister = false
      let deletedAnyCache = false

      try {
        if ('serviceWorker' in navigator) {
          const regs = await navigator.serviceWorker.getRegistrations()
          if (regs && regs.length) {
            await Promise.all(
              regs.map((r) => r.unregister().then((ok) => { didUnregister = didUnregister || !!ok }).catch(() => {}))
            )
          }
        }
      } catch {}

      try {
        if ('caches' in window) {
          const keys = await caches.keys()
          if (keys && keys.length) {
            const results = await Promise.all(keys.map((k) => caches.delete(k).catch(() => false)))
            deletedAnyCache = results.some(Boolean)
          }
        }
      } catch {}

      const shouldReload = didUnregister || deletedAnyCache
      try {
        sessionStorage.setItem('let_sw_cleanup_done', '1')
      } catch {}

      if (shouldReload) {
        try { window.location.reload() } catch {}
      }
    })()
  }, [])

  return null
}
